<template>

  <div class="container">
    <div class="loading" v-if="!isallReady">
      <img src="/static/main/loading.gif">
    </div>
    <div class="tool_header">
      <button class="tool_header_left act" @click="allSave()"><img src="/static/main/baocun.png">保存</button>
    </div>
    <audio :src="audioUrl" loop preload ref="horn" style="position: fixed;z-index:-1;opacity:0" @play="handlePlay"
           @pause="handlePause"></audio>
    <div class="tool_main">
      <div class="overlay-left">
        <div :class="toolAct == 0 ? 'overlay-left-li act' : 'overlay-left-li'" @click="changeTool(0)">
          <img src="/static/main/look.png">
          <span>视角</span>
        </div>
        <div :class="toolAct == 1 ? 'overlay-left-li act' : 'overlay-left-li'" @click="changeTool(1)">
          <img src="/static/main/hot.png">
          <span>热点</span>
        </div>
        <div :class="toolAct == 2 ? 'overlay-left-li act' : 'overlay-left-li'" @click="changeTool(2)">
          <img src="/static/main/audio.png">
          <span>音乐</span>
        </div>
        <div :class="toolAct == 3 ? 'overlay-left-li act' : 'overlay-left-li'" @click="changeTool(3)">
          <img src="/static/main/video.png">
          <span>视频</span>
        </div>
      </div>
      <div class="overlay-center">
        <div class="overlay-center-pano">
          <div class="overlay-view" v-if="toolAct == 0">
            <img src="/static/main/bg.png">
            <div class="overlay-view-title" @click="setAsDefaultView">把当前视角设为第一视角</div>
          </div>
<!--          <img src="/static/main/audio.png" v-show="isAudioadd" class="panoAudio" @click="ctrAudio()">-->
          <!-- 视频播放器 -->
          <div class="overlay-view" v-if="videoLayerShow" style="background: #000000;">
            <div class="overlay-but"><img src="/static/main/close.png" @click="closeVideoLayer"/></div>
            <video ref="video" :src="videoActive" controls="controls" class="overlay-video"></video>
          </div>
          <!--富文本内容弹窗-->
          <div class="edit_container" v-if="showEditorHtml" style="padding: 30px 0;">
            <div class="edit_close"><img src="/static/main/close.png" @click="editorHtmlShow(false)"></div>
            <div class="quill-main ql-editor" id="editorDiv" v-html="editorhtml"></div>
          </div>
          <!-- 富文本编辑器-->
          <div class="edit_container" v-if="iseditorShow">
            <div class="edit_close"><img src="/static/main/close.png" @click="editorShow(false)"></div>
            <!--            <h4 style="margin-bottom: 10px;">热点内容：</h4>-->
            <!--            <quill-editor-->
            <!--                v-model="content"-->
            <!--                ref="myQuillEditor"-->
            <!--                :options="editorOption"-->
            <!--                @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"-->
            <!--                @change="onEditorChange($event)">-->
            <!--            </quill-editor>-->
            <div class="quill-main">
              <quill-editor ref="myQuillEditor" v-model="content" :options="quillOption" @blur="onEditorBlur($event)"
                            style="border: none;"
                            @focus="onEditorFocus($event)" @change="onEditorChange($event)">
              </quill-editor>
            </div>
            <button class="tool-right-but quill-but" @click="saveEditor">确定</button>
          </div>

          <div id="pano" v-show="isallReady">
          </div>
        </div>
        <!-- 场景导航 -->
        <NavList :sceneList="sceneApiList" :currentSceneId="currentSceneId" @goToScene="goToScene" @addPano="addPano"
                 @delScenceId="delScenceId"
                 :sceneListNumData="sceneListNum" @changeScence="changeScence" :isShow="false"/>
      </div>
      <div class="overlay-right">
        <div class="overlay-right-title">{{ activeToolName }}</div>
        <div class="overlay-right-content">
          <div v-show="toolAct == 0">
            <div class="tool-right-section">
              <div>当前视角</div>
              <div class="tool-right-section-content">
                <div class="tool-right-section-content-bg"></div>
                <div id="panoMini" v-show="isfirstViewReady">
                </div>
              </div>
            </div>
            <div class="tool-right-section" style="margin-top: 20px;">
              <div>当前场景名</div>
              <div class="tool-right-section-ul" style="display: flex;">
                <!-- <div class="tool-right-section-content-bg"> -->
                <input v-model="currentSceneName" class="tool-right-input" placeholder=""
                       placeholder-class="input-placeholder" @input=""/>

                <!-- </div> -->
                <button class="tool-right-but" @click="changeScenceName">修改</button>
              </div>
            </div>
          </div>
          <div v-show="toolAct == 1">
            <div v-show="!isAddHotspotShow">
              <div class="tool-right-section" v-if="HotSpotList.length > 0">
                <div class="tool-right-section-ul">
                  <ul>
                    <li v-for="(item, index) in HotSpotList" :key="index">
                      <div class="section-span1">
                        <img :src="item.peak_tooltip?.indexOf('gif') > -1 ? item.peak_tooltip : item.url"
                             class="section-img"/>{{
                          item.title
                        }}
                      </div>
                      <div>
                        <img src="/static/main/del.png" class="section-span" @click="removeHotSpot(item)"
                             style="margin-right: 5px;"/>
                        <img src="/static/main/edit.png" class="section-span" @click="editHotSpot(item)"/>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <button class="tool-right-but" @click="showTool(1)">添加热点</button>
            </div>
          </div>
          <div v-show="toolAct == 3">
            <div v-show="!isAddHotspotShow">
              <div class="tool-right-section" v-if="videoList.length > 0">
                <div class="tool-right-section-ul">
                  <ul>
                    <li v-for="(item, index) in videoList" :key="index">
                      <div class="section-span1">
                        <img :src="item.url" class="section-img"/>
                        <span>{{
                            item.title
                          }}</span>
                      </div>
                      <img src="/static/main/del.png" class="section-span" @click="removeHotSpot(item)"/>
                      <!--                      <img src="/static/main/edit.png" class="section-span" @click="removeHotSpot(item)" />-->
                    </li>
                  </ul>
                </div>
              </div>
              <button class="tool-right-but" @click="showTool(4)">添加视频</button>
            </div>
          </div>
          <div v-show="isAddHotspotShow">
            <AddHotspot v-model="isAddHotspotShow" :krpano="krpano" :sceneList="sceneList" :toolAct="toolAct"
                        :iseditorShow="iseditorShow" :content="content"
                        :currentSceneId="currentSceneId" :clickMouseLocation="clickMouseLocation" :panoInfo="panoInfo"
                        :hotspotInfo="hotspotInfo" @delHotSpot="delHotSpot" @editorShow="editorShow"
                        @setAudio="setAudio" @addHotSpot="clickAddHotSpot" @edit="chanageHotSpot"/>
          </div>
          <!--富文本内容-->
          <div v-if="toolAct == 2">

            <!-- <div class="tool-right-section" v-show="!isAddHotspotShow"> -->
            <div v-show="!isAddHotspotShow">
              <div>当前场景音乐</div>
              <div v-if="!audioUrlAct" class="tool-right-but1">暂无</div>
              <button @click="choseAudio(1)" v-if="audioUrlAct" class="tool-right-but">{{
                  audioUrl == audioUrlAct && isAudioNow == 1 && isAudioPlay ? '暂停' : '播放'
                }}
              </button>
              <div>全部场景音乐</div>
              <div v-if="!audioAllUrl" class="tool-right-but1">暂无</div>
              <button @click="choseAudio(2)" v-if="audioAllUrl" class="tool-right-but">{{
                  audioUrl == audioAllUrl && isAudioNow == 2 && isAudioPlay ? '暂停' : '播放'
                }}
              </button>
              <button class="tool-right-but" style="margin-top: 50px;" @click="showTool(2)">
                {{ !audioAllUrl && !audioUrlAct ? '添加音乐' : '更换音乐' }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div :class="errorMsg ? 'mssage act' : 'mssage'" v-show="errorMsg">{{ errorMsg }}</div>
  </div>
</template>
<script>
import NavList from "../../src/components/NavList.vue";
import Tools from "../../src/components/Tools.vue";
import AddHotspot from "../../src/components/AddHotspot.vue";
import {access_token} from '../../src/api/request.js'
import {
  tblMediaAssetsId,
  tblHotspotById,
  addTblHotspot,
  tblMediaAssetsEdit,
  deleteHotspotData
} from "../../src/api/api.js";
import {set} from "store";

import {quillEditor} from "vue-quill-editor"; //调用编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// import '@/util/advanced-green-theme.less'
import quillConfig from '@/util/quill-config.js'

export default {
  name: "KrpanoView",
  components: {
    NavList,
    Tools,
    AddHotspot,
    quillEditor
  },
  data() {
    return {
      editorhtml: '',
      iseditorShow: false,
      videoLayerShow: false,
      movingSpot: {},
      videoActive: '',
      errorMsg: '',
      toolAct: 0,
      hlookat: '',
      vlookat: '',
      isAudioadd: false,//全景中的音乐图标是否显示
      isallReady: false,//全景是否加载完了
      isfirstViewReady: false, //第一视角是否加载完了
      activeToolName: '视角',
      isSelectAudio: false,
      isShowHot: false,
      isAudioNow: 0,
      isAudioPlay: false,
      audioUrl: '',
      canShowLeft: false,
      krpano: null,
      Minikrpano: null,
      scenceImgId: '',
      videoUrl: '',
      currentSceneName: '',//当前场景图名称
      // sceneList: [], // 场景集合
      panoInfo: {},//页面传过来 的信息
      currentSceneId: 0, // 当前场景的索引
      addHotTab: 0,
      trackMouseId: null,
      isAddHotspotShow: false,
      clickMouseLocation: {}, // 点击的位置
      moveIntervalId: null, // 移动定时器
      toAddHotSpot: {},//添加热点
      sceneList: [],//场景集合
      sceneApiList: [],//场景集合
      HotSpotList: [],
      hotspotInfo: {},
      videoList: [
        //   {
        //   ath: "-156.21986347730666",
        //   atv: "12.749842783399309",
        //   distorted: true,
        //   edge: "center",
        //   loop: true,
        //   name: "peak_hotspot_1735197297604",
        //   pausedonstart: true,
        //   peak_to_scene: "scene_64e5e205662842f49d512cf8415f4df1",
        //   peak_to_sceneId: 0,
        //   peak_tooltip: "",
        //   peak_type: 1,
        //   posterurl: "http://192.168.0.122:9999/admin/sys-file/oss/file?fileName=d0bca0c0f0c9472e8c6c07ad40c6719f.png",
        //   scale: 1,
        //   style: null,
        //   title: "反倒是",
        //   type: "image",
        //   // url: "static/plugins/videoplayer.js",
        //   videourl: "http://192.168.0.122:9999/admin/sys-file/oss/file?fileName=ec7318ac1b734735afcb096edd1672b1.mp4",
        //   οnclick: "togglepause();",
        // }
      ],
      // tourUrl: 'http://192.168.0.122:8889/',
      tourUrl: '/img/',
      audioList: [],
      audioUrlAct: '',
      audioAllUrl: '',
      audioHttp: 'https://qjlc.dawangdawang.cn/',
      sceneListNum: [],
      content: '',
      quillOption: quillConfig,
      showEditorHtml: false,//是否显示富文本内容弹窗
    };
  },
  props: {
    groupId: {
      require: true,
    },
    id: {
      require: true,
    },
    title: {
      require: true,
    },
  },
  // emits: [
  //   "goToScene", // 跳转视图
  // ],
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  mounted() {
    //获取地址中的参数
    if (this.$route.query.length > 0) {
      this.panoInfo = this.$route.query
      this.tourUrl = this.tourUrl + this.panoInfo.groupId//本地测试时，需要注释掉
      localStorage.setItem('access_token', this.panoInfo.access_token);
      this.getPanoInfo()//获取全景信息
    } else {
      let windowStr = window.location.href.lastIndexOf('?')
      let windowUrl = window.location.href.substring(windowStr + 1, window.location.href.length);
      let urlArr = windowUrl.split('&');
      let urlObj = {};
      for (let i = 0; i < urlArr.length; i++) {
        let urlItem = urlArr[i].split('=');
        if (urlItem[0] == 'title') {
          urlItem[1] = decodeURIComponent(urlItem[1])
        }
        urlObj[urlItem[0]] = urlItem[1];
      }
      this.panoInfo = urlObj
      localStorage.setItem('access_token', this.panoInfo.access_token);
      this.tourUrl = this.tourUrl + this.panoInfo.groupId//本地测试时，需要注释掉
      this.getPanoInfo()//获取全景信息
    }
    if (this.toolAct == 0) {
      this.activeToolName = '视角'
    } else if (this.toolAct == 1) {
      this.activeToolName = '热点'
    } else if (this.toolAct == 2) {
      this.activeToolName = '音乐'
    } else if (this.toolAct == 3) {
      this.activeToolName = '视频'
    }
  },

  methods: {
    //热点富文本内容弹窗显示隐藏
    editorHtmlShow(e) {
      this.showEditorHtml = e
    },
    saveEditor() {//保存富文本内容
      this.iseditorShow = false
      this.editorhtml = this.content
      console.log(this.content, this.editorhtml)
    },
    editorShow(e) {
      console.log(e, '打开关闭')
      this.iseditorShow = e
      if (e) {
        this.showEditorHtml = false
      }
    },
    onEditorReady(editor) { // 准备编辑器

    },
    onEditorBlur(e) {
      // console.log(e,'blur')
    }, // 失去焦点事件
    onEditorFocus(e) {
      // console.log(e,'focus')
    }, // 获得焦点事件
    onEditorChange(e) {
      this.content = e.html
    }, // 内容改变事件
    //点击确认修改场景名称
    changeScenceName() {
      console.log(this.currentSceneName)
      let data = {
        title: this.currentSceneName,
        groupId: this.panoInfo.groupId,
        fileName: this.scenceImgId
      }

      tblMediaAssetsEdit(data, this.panoInfo.access_token).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '设置成功'
          });
          setTimeout(() => {
            location.reload(true);
          }, 2000)
        } else {
          this.$message({
            type: 'error',
            message: '设置失败'
          });
        }
      })
    },
    //删除场景
    delScenceId(e) {
      this.$confirm('此操作将永久删除该场景, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let data = {
          title: e.title,
          id: this.panoInfo.groupId
        }

        deleteHotspotData(data, this.panoInfo.access_token).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            setTimeout(() => {
              location.reload(true);
            }, 2000)
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //接收拖动图片切换位置以后的场景列表
    changeScence(e) {
      console.log(e)
      this.sceneListNum = e
    },
    //左侧按钮切换
    changeTool(e) {
      this.toolAct = e
      this.isAddHotspotShow = false//这里改了
      if (e == 0) {
        this.activeToolName = '视角'
        //视角导航时，再显示视角窗
        setTimeout(() => {
          this.setFirstView(1)
        }, 200)
        this.clearAudio()
        // 左侧菜单显示开始的列表
      } else if (e == 1) {
        this.activeToolName = '热点'
        this.clearAudio()
      } else if (e == 2) {
        this.activeToolName = '音乐'
        // this.getAudioList() //获取音乐列表
      } else if (e == 3) {
        this.activeToolName = '视频'
        this.clearAudio()
      }
    },
    //取消背景音乐
    clearAudio() {
      this.audioUrl = ''
      this.isAudioadd = false
      this.isAudioPlay = false//任何操作都会暂停播放音乐
      if (this.$refs.horn) {
        this.$refs.horn.pause();//暂停
      }
      this.isAudioNow = 0//用来判断当前点击的是当前场景还是全局背景音乐
      // this.updateHotSpotData()
    },
    //点击设置全部场景音乐
    setAudio(e) {
      this.audioUrl = e.audioUrl
      this.isAudioadd = true
      if (e.type == 1) {//当前场景背景音乐
        this.audioUrlAct = e.audioUrl
        this.updateHotSpotData()
      } else if (e.type == 2) {//全局背景音乐
        this.audioAllUrl = e.audioUrl
        // this.allSave()
      }
      this.isAudioadd = true

      this.$message({
        type: 'success',
        message: '设置成功!'
      });
    },
    //点击设置当前场景音乐
    setSenceAudio() {

      if (this.audioUrl == '') {
        this.$message({
          type: 'info',
          message: '请先上传音乐!'
        });
        return
      }
      this.isAudioadd = true
      this.$message({
        type: 'success',
        message: '设置成功!'
      });
      this.updateHotSpotData()
    },

    handlePlay() {
      // console.log('播放')
      this.isAudioPlay = true
      // this.isAudioNow = 0//用来判断当前点击的是当前场景还是全局背景音乐
    },
    handlePause() {
      this.isAudioPlay = false
    },
    // 音频控制
    ctrAudio() {
      if (!this.$refs.horn) return;

      if (this.isAudioPlay) {
        this.$refs.horn.pause();
        this.isAudioPlay = false;
      } else {
        this.$refs.horn.play().catch(error => {
          console.warn('Audio playback failed:', error);
          this.$message({
            type: 'error',
            message: '音频播放失败，请检查浏览器设置!'
          });
        });
      }
    },
    //显示选择背景音乐按钮
    // selectAudio() {
    //   this.isSelectAudio = !this.isSelectAudio
    // },
    //选中音乐
    choseAudio(e) {

      if (this.isAudioNow == e && this.isAudioNow != 0) {//如果点击的是暂停，之前播放，现在暂停
        this.isAudioNow = 0//用来判断当前点击的是当前场景还是全局背景音乐
        this.isAudioPlay = false//任何操作都会暂停播放音乐
        this.$refs.horn.pause();//暂停
      } else {
        this.isAudioNow = e//用来判断当前点击的是当前场景还是全局背景音乐
        //如果不想等，才是需要处理播放
        if (e == 1) {//当前场景背景音乐
          this.audioUrl = this.audioUrlAct
        } else if (e == 2) {//全局背景音乐
          this.audioUrl = this.audioAllUrl
        }
        this.isAudioPlay = true
        setTimeout(() => {
          this.$refs.horn.play();//播放
        }, 500)
      }
    },
    //获取音频频列表
    getAudioList() {
      tblMediaAssetsId({groupId: this.panoInfo.groupId, type: 4}, this.panoInfo.access_token).then((res) => {
        this.audioList = res.data.records
      }).catch((err) => {

      })
    },
    //视角修改模块
    setAsDefaultView() {
      // console.log(this.currentSceneId)
      // console.log(this.krpano.get("view.hlookat"))
      this.sceneList[this.currentSceneId].initH = this.krpano.get("view.hlookat");
      this.sceneList[this.currentSceneId].initV = this.krpano.get("view.vlookat");
      this.sceneList[this.currentSceneId].fov = this.krpano.get("view.fov");
      //设置小窗第一视角
      this.Minikrpano.set("view.hlookat", this.krpano.get("view.hlookat"));
      this.Minikrpano.set("view.vlookat", this.krpano.get("view.vlookat"));
      this.hlookat = this.krpano.get("view.hlookat");
      this.vlookat = this.krpano.get("view.vlookat");
    },


    //获取场景信息
    getPanoInfo() {
      tblHotspotById(this.panoInfo.groupId, this.panoInfo.access_token).then(res => {
        if (res.data) {
          if (res.data.glMusic) {//如果有全局背景音乐，把全局背景音乐拿出来
            this.audioAllUrl = res.data.glMusic
          }
          this.sceneApiList = JSON.parse(res.data.content)//全局场景保留备用
          // console.log(this.sceneApiList, 'this.sceneApiList')
          this.sceneList = JSON.parse(res.data.content)//全局场景
          // console.log(this.sceneList, 'this.sceneList')
          // if (res.data.peakToScene) {
          if (res.data.peakToScene && res.data.peakToScene != '[]') {//场景排序，如果数据中有场景排序，那么导航根据这个排序来排
            this.sceneListNum = JSON.parse(res.data.peakToScene)
            this.currentSceneId = this.sceneListNum[0];//获取当前显示的第一个场景是第几个场景
          }
        }
        this.initPano()//初始化全景
      }).catch(err => {
      })
    },
    //加载初始场景
    initPano() {
      document.getElementById('pano').innerHTML = ''//防止进入时重复使用上一个场景
      // console.log(this.tourUrl + "/vtour/tour.xml")
      let time2 = setTimeout(() => {//加延时，怕场景信息还没处理完
        window.embedpano({
          // swf: this.tourUrl + "/vtour2/tour.swf", // 测试用，正式的需要注释掉
          // xml: this.tourUrl + "/vtour2/tour.xml",
          swf: this.tourUrl + "/vtour/tour.swf", // 有则表示加载 flash 引擎，如果设置 html5:only 则不需要该值
          xml: this.tourUrl + "/vtour/tour.xml?t=" + new Date().getTime(), // 启动时的配置文件，保证是最新的文件
          target: "pano", // 要渲染到的目标容器 ID
          html5: "auto", // 如果有需要用到 flash ，可设置为 auto
          //id: "krpanoSWFObject", // 默认的 krpano 对象，每一个 viewer 对应唯一 id ，与 JS 交互时要用到
          mobilescale: 1.0, // 移动设备缩放，1 表示不缩放，默认 0.5
          passQueryParameters: true, // 是否接受 URL 传参，例如：tour.html?html5=only&startscene=scene2
          onready: (krpano_interface) => {
            this.krpano = krpano_interface;
            // console.log('一')
            clearTimeout(time2)
            let that = this
            let readyPano = setTimeout(() => {//初始化不完全，后继操作拿不到数据，加延时
              that.initPanoInfo();
              clearTimeout(readyPano)
            }, 2000)
            //获取场景数据，总是拿不到， 加循环，直到拿到位置
            let readyScene = setInterval(() => {//初始化不完全，后继操作拿不到数据，加延时
              that.initSceneList()
              if (this.sceneList.length > 0) {
                clearInterval(readyScene)
                that.initSceneView()//处理场景数据
              }
            }, 1000)
          },
        });

        // window.myGetXML = this.transmitXML;
      }, 200)
    },
    //处理初始化数据
    initSceneList() {
      // 获取场景
      if (this.sceneList.length == 0) {//如果接口返回的场景列表中是空的，也就是生成以后还没有做任何处理过的场景
        this.sceneList = this.krpano.get("scene").getArray(); // 所有场景图
        this.sceneApiList = this.sceneList
      } else {//处理场景数组中标题，如果场景中remark和xml文件中的场景remark不相同时，需要显示xml文件中的，不显示热点接口中调的
        let tourScene = this.krpano.get("scene").getArray(); // 所有场景图
        //为防止场景数据不能及时拿到，加延时
        let tourSceneTime = setTimeout(() => {
          for (let n = 0; n < tourScene.length; n++) {
            if (this.sceneApiList[n].remark != tourScene[n].remark) {
              this.sceneApiList[n].remark = tourScene[n].remark
              this.sceneList[n].remark = tourScene[n].remark
            }
          }
          clearTimeout(tourSceneTime)
        }, 1500)
      }
    },
    //获取场景后，处理当前场景初始化视角等
    initSceneView() {

      if (this.sceneApiList) {
        //设置第一视角
        if (this.sceneApiList[this.currentSceneId]) {
          if (this.sceneApiList[this.currentSceneId].initH) {
            this.krpano.set("view.hlookat", this.sceneApiList[this.currentSceneId].initH);
            this.krpano.set("view.vlookat", this.sceneApiList[this.currentSceneId].initV)
          }
        }
      }
      //视角窗显示(第一视角设置以后)
      if (this.toolAct == 0) {//视角导航时，再显示视角窗
        this.setFirstView(0)
      }
      //如果需要显示的第一个场景不是场景列表中的第一个场景时，场景加载完成以后，需要跳转到该场景中
      // if (this.currentSceneId && this.currentSceneId != 0) {
      if (!this.currentSceneId) {//如果第一场景id没有，就默认显示第一个场景，并且做跳转，用来处理热点显示问题
        this.currentSceneId = 0
      }
      console.log(this.sceneList[this.currentSceneId])
      // console.log(this.currentSceneId)
      let times3 = setTimeout(() => {
        this.goToScene({
          peak_to_scene: this.sceneList[this.currentSceneId].name,
          peak_to_sceneId: this.currentSceneId,
        });
        //第一视角和控制栏都设置好以后再显示
        this.isallReady = true
        clearTimeout(times3)
      }, 500)

    },
    //初始化所有场景中的信息
    initPanoInfo() {
      // 通过设置这些图层的visible属性为false，可以隐藏这些图层，从而实现界面上的一些效果，比如隐藏控制栏、底部分割线和滚动窗口等。 */
      //隐藏下面的控制栏
      this.krpano.set("layer[skin_control_bar].visible", false);
      this.krpano.set("layer[skin_splitter_bottom].visible", false);
      this.krpano.set("layer[skin_scroll_window].visible", false);
      let timeTo5 = 0
      let interval1 = setInterval(() => {//隐藏控制栏时，总是已经设置false了，但是还是显示，是krpano初始化时长的问题，无法规避
        // console.log(that.krpano.get("layer[skin_control_bar].visible"))
        this.krpano.set("layer[skin_control_bar].visible", false);
        this.krpano.set("layer[skin_splitter_bottom].visible", false);
        this.krpano.set("layer[skin_scroll_window].visible", false);
        if (timeTo5 > this.sceneList.length * 2) {
          clearInterval(interval1)
        }
      }, 1000)

    },
    //视角窗口的小窗
    setFirstView(e) {
      if (e == 0) {//如果是第一次进入全景图，则显示小窗
        this.isfirstViewReady = false
        window.embedpano({
          swf: this.tourUrl + "/vtour/tour.swf", // 有则表示加载 flash 引擎，如果设置 html5:only 则不需要该值
          xml: this.tourUrl + "/vtour/tour.xml?t=" + new Date().getTime(), // 启动时的配置文件
          target: "panoMini", // 要渲染到的目标容器 ID
          html5: "auto", // 如果有需要用到 flash ，可设置为 auto
          //id: "krpanoSWFObject", // 默认的 krpano 对象，每一个 viewer 对应唯一 id ，与 JS 交互时要用到
          mobilescale: 1.0, // 移动设备缩放，1 表示不缩放，默认 0.5
          passQueryParameters: true, // 是否接受 URL 传参，例如：tour.html?html5=only&startscene=scene2
          onready: (Minikrpano) => {
            this.Minikrpano = Minikrpano
            this.Minikrpano.set("layer[skin_control_bar].visible", false);
            let times1 = setTimeout(() => {
              //设置第一视角
              this.Minikrpano.set("view.hlookat", this.krpano.get("view.hlookat"));
              this.Minikrpano.set("view.vlookat", this.krpano.get("view.vlookat"));
              //隐藏下面的控制栏
              this.Minikrpano.set("layer[skin_control_bar].visible", false);
              this.Minikrpano.set("layer[skin_splitter_bottom].visible", false);
              this.Minikrpano.set("layer[skin_scroll_window].visible", false);
              let timeTo6 = 0
              let interval2 = setInterval(() => {//隐藏控制栏时，总是已经设置false了，但是还是显示，是krpano的问题，无法规避
                this.Minikrpano.set("layer[skin_control_bar].visible", false);
                this.Minikrpano.set("layer[skin_splitter_bottom].visible", false);
                this.Minikrpano.set("layer[skin_scroll_window].visible", false);
                if (timeTo6 > 6) {
                  clearInterval(interval2)
                }
              }, 1000)
              this.isfirstViewReady = true//控件设置好以后显示视角窗
              clearTimeout(times1)
            }, 500)
          },
          onerror: (error) => {
            // console.log(error);
          },
        });

      } else {
        // krpano.call("loadpano('panoMini',null,MERGE,BLEND(1));");
        this.isfirstViewReady = true
      }
    },

    /**
     * 处理去加载场景热点
     */
    getSceneHotspot() {
      // 热点显示
      console.log(this.HotSpotList)
      this.HotSpotList.forEach((item) => {
        this.addhotspoti(item)
      });
      //视频显示
      this.videoList.forEach((item) => {
        this.addhotspoti(item)
      });
    },
    // 关闭热点
    hideAddHotSpot() {
      this.isAddHotspotShow = false;
      window.clearInterval(this.moveIntervalId);
      this.toAddHotSpot = {};
    },
    //热点列表显示
    showHot() {
      this.isShowHot = !this.isShowHot
    },
    //添加热点弹窗
    showTool(n) {
      if (n == 4) {//添加视频
        this.isAddHotspotShow = true;
        this.activeToolName = "添加视频"
      } else if (n == 1) {//添加热点
        this.isAddHotspotShow = true;
        this.activeToolName = "添加热点"
      } else if (n == 2) {//添加音乐
        this.isAddHotspotShow = true;
        this.activeToolName = "音乐设置"
      }
    },
    clickAddHotSpot(hotspotInfo) {
      // 计算中间位置的球面坐标
      this.krpano.set("halfHeight", this.krpano.get("stageheight") / 2);
      this.krpano.set("halfWidth", this.krpano.get("stagewidth") / 2);
      this.krpano.call("screentosphere(halfWidth,halfHeight,init_h,init_v);");
      var init_h = this.krpano.get("init_h");
      var init_v = this.krpano.get("init_v");
      console.log(init_h)
      console.log(init_v)
      hotspotInfo.ath = init_h;
      hotspotInfo.atv = init_v;
      console.log(hotspotInfo, 'qian')
      // //添加热点
      this.addhotspoti(hotspotInfo)
      if (hotspotInfo.peak_type == 1) {//如果是视频，推到视频列表里面
        this.videoList.push(hotspotInfo)
      } else {
        // if(hotspotInfo.peak_tooltip && hotspotInfo.peak_tooltip.indexOf("gif") != -1){
        //   hotspotInfo
        this.HotSpotList.push(hotspotInfo)
        // }
      }
      this.updateHotSpotData();
      this.hideAddHotSpot();
    },
    //场景中添加热点
    addhotspoti(hotspotInfo) {
      if (!this.krpano || !hotspotInfo?.name) return;

      const newHotSpotName = hotspotInfo.name;
      console.log(hotspotInfo, '热点信息')
      // 移除已存在的同名热点
      if (this.krpano.get(`hotspot[${newHotSpotName}]`)) {
        this.krpano.call(`removehotspot(${newHotSpotName})`);
      }

      this.krpano.call("addhotspot(" + newHotSpotName + ");");
      this.krpano.set("hotspot[" + newHotSpotName + "].url", hotspotInfo.url);
      this.krpano.set("hotspot[" + newHotSpotName + "].ath", hotspotInfo.ath);
      this.krpano.set("hotspot[" + newHotSpotName + "].atv", hotspotInfo.atv);
      this.krpano.set("hotspot[" + newHotSpotName + "].title", hotspotInfo.title);
      this.krpano.set("hotspot[" + newHotSpotName + "].linkedscene", hotspotInfo.linkedscene);
      this.krpano.set("hotspot[" + newHotSpotName + "].dive", hotspotInfo.dive);
      this.krpano.set("hotspot[" + newHotSpotName + "].edge", hotspotInfo.edge || 'center');
      this.krpano.set("hotspot[" + newHotSpotName + "].scale", hotspotInfo.scale || 1);//设置图片不能拖动
      this.krpano.set("hotspot[" + newHotSpotName + "].peak_type", hotspotInfo.peak_type);
      this.krpano.set("hotspot[" + newHotSpotName + "].peak_sceneId", hotspotInfo.peak_sceneId);
      this.krpano.set("hotspot[" + newHotSpotName + "].peak_to_scene", hotspotInfo.peak_to_scene);
      this.krpano.set("hotspot[" + newHotSpotName + "].peak_to_sceneId", hotspotInfo.peak_to_sceneId);


      // 处理动态热点（GIF）
      if (hotspotInfo.url && hotspotInfo.url.indexOf("gif") !== -1) {
        // 设置动态效果相关属性
        this.krpano.set("hotspot[" + newHotSpotName + "].peak_tooltip", hotspotInfo.url);
        // 使用更安全的动画设置
        this.krpano.set("hotspot[" + newHotSpotName + "].style", 'skin_hotspotstyle_animation_tooltip');
        this.krpano.set("hotspot[" + newHotSpotName + "].distorted", 'false');
        this.krpano.set("hotspot[" + newHotSpotName + "].zoom", 'true');
        this.krpano.set("hotspot[" + newHotSpotName + "].renderer", 'css3d');
        // 设置动画参数
        this.krpano.set("hotspot[" + newHotSpotName + "].frame", '0');
        this.krpano.set("hotspot[" + newHotSpotName + "].framewidth", '100');
        this.krpano.set("hotspot[" + newHotSpotName + "].frameheight", '100');
        this.krpano.set("hotspot[" + newHotSpotName + "].framerate", '15');
        //加载动态效果+文字标题
        this.krpano.set("hotspot[" + newHotSpotName + "].onloaded", `if(loaded,
            copy(frame,0);
            delayedcall(0.0,if(loaded,set(frame,calc(frame + 1)); if(frame GE 15, set(frame,0));));
          );add_hotspot_tooltip_top()`);

      } else {
        //加载效果
        this.krpano.set("hotspot[" + newHotSpotName + "].onloaded", `add_hotspot_tooltip_top()`);
      }


      // 添加视频相关属性（如果是视频热点）
      if (hotspotInfo.peak_type === 1) {
        // 设置视频参数
        this.krpano.set("hotspot[" + newHotSpotName + "].videourl", hotspotInfo.videourl);
        this.krpano.set("hotspot[" + newHotSpotName + "].posterurl", hotspotInfo.posterurl);
        this.krpano.set("hotspot[" + newHotSpotName + "].loop", hotspotInfo.loop || true);
        this.krpano.set("hotspot[" + newHotSpotName + "].pausedonstart", hotspotInfo.pausedonstart || true);
        this.krpano.set("hotspot[" + newHotSpotName + "].distorted", hotspotInfo.distorted || false);
      } else if (hotspotInfo.peak_type == 5) {//文本弹窗
        if (hotspotInfo.editorhtml) {
          this.krpano.set("hotspot[" + newHotSpotName + "].editorhtml", hotspotInfo.editorhtml);
        }
        let that = this
        let clearHtml = setTimeout(() => {
          that.content = ''
          clearTimeout(clearHtml)
        }, 1000)
      }
      // 执行添加热点命令
      try {
        // console.log('addCommand', this.sceneList);
        // this.krpano.call(addCommand);

        // console.log('addCommand2', this.sceneList);
        // 确保热点创建成功后再设置事件
        setTimeout(() => {
          const hotspot = this.krpano.get(`hotspot[${newHotSpotName}]`);
          if (hotspot) {
            this.hotSpotInitEvent(newHotSpotName, hotspotInfo);
          }
        }, 100);
      } catch (error) {
        console.error('Error adding hotspot:', error);

        this.$message({
          type: 'error',
          message: '添加热点失败，请重试!'
        });
      }
    },

    //富文本热点点击事件
    showEditor(hotspotInfo) {
      this.editorhtml = hotspotInfo.editorhtml
      this.showEditorHtml = true
    },
    //视频热点点击事件
    //h5页面播放器
    showVideoLayer(hotspotInfo) {
      this.videoActive = hotspotInfo.videourl
      this.videoLayerShow = true
    },
    closeVideoLayer() {
      this.videoLayerShow = false
      this.$refs.video.pause();//暂停视频
    },
    //移除当前热点
    removeHotSpot(e) {
      this.krpano.call("removehotspot(" + e.name + ")");
      //移除视频热点列表
      if (e.peak_type == 1) {
        this.videoList = this.videoList.filter(function (item) {
          return item.name !== e.name
        })
      } else {
        //移除热点列表
        this.HotSpotList = this.HotSpotList.filter(function (item) {
          return item.name !== e.name
        })
      }
      this.updateHotSpotData();
    },
    chanageHotSpot(e) {
      this.isAddHotspotShow = false;
      this.addhotspoti(e)
    },
    //编辑当前热点
    editHotSpot(e) {
      console.log(e, '修改热点信息')
      this.hotspotInfo = e//获取信息给热点中
      this.isAddHotspotShow = true;
      this.activeToolName = "修改热点"
      if (e.editorhtml) {
        this.content = e.editorhtml;
      }
    },
    // 清除编辑的热点数据
    delHotSpot() {
      this.hotspotInfo = {}
    },
    /**
     * 预览
     */
    // preview() {
    //   window.open("static/vtour1/tour.html");
    // },
    //获取当前场景热点
    getSceneHotspotNow(e) {//这里改了
      //把当前场景的热点拿出来显示
      let HotSpotList = []//普通热点
      let videoList = []//视频
      if (this.sceneList[e]) {
        if (this.sceneList[e].hotSpots) {
          this.sceneList[e].hotSpots.forEach(hot => {
            if (hot.peak_type == 1) {//视频热点
              videoList.push(hot)
            } else if (hot.peak_type && hot.peak_type != 1) {             //普通热点
              HotSpotList.push(hot)
            }
          })
        }
        this.HotSpotList = HotSpotList

        this.videoList = videoList
        //把当前场景的背景音乐拿出来显示
        this.audioUrlAct = ''
        this.audioUrl = ''
        if (this.sceneList[e].audioUrl) {//如果有当前场景的背景音乐，就显示按钮，并且赋值
          this.audioUrl = this.sceneList[e].audioUrl
          this.audioUrlAct = this.sceneList[e].audioUrl
          this.isAudioadd = true
        } else if (this.audioAllUrl) {          //如果没有当前场景的背景音乐，但是有全局背景音乐，就显示按钮，并且赋值
          this.audioUrl = this.audioAllUrl
          this.isAudioadd = true
        } else {//如果既没有当前场景音乐，也没有全部背景音乐，就都不显示
          this.audioUrl = ''
          this.isAudioadd = false
        }
        // console.log(this.audioUrl)
        this.isAddHotspotShow = false//右侧窗口初始化到仅展示状态
      }
    },
    //保存全景
    allSave() {
      // 获取场景
      let content = JSON.stringify(this.sceneList)
      let data = {
        name: this.panoInfo.title,//string 热点名称可选
        id: this.panoInfo.groupId,//string 必需场景图的id 必填场景图的id
        peakSceneId: this.panoInfo.groupId,//string 必需场景图的id 必填场景图的id
        glMusic: this.audioAllUrl,
        peakToSceneId: '',//string 要跳转的场景图id可选
        peakTooltip: '',//string 设点提示标签内容可选
        content: content,//string 内容信息
        peakToScene: JSON.stringify(this.sceneListNum),
      }
      let that = this
      // return
      addTblHotspot(data, this.panoInfo.access_token).then((res) => {
        this.$message({
          type: 'success',
          message: '保存成功'
        });
      }).catch((err) => {

      })
    },
    //信息提示
    changeMsg(e) {
      this.errorMsg = e
      let clears
      clears = setTimeout(() => {
        this.errorMsg = ''
        clearTimeout(clears)
      }, 3000)
    },
    //加载热点事件
    hotSpotInitEvent(spotName, hotspotInfo) {
      if (!this.krpano || !spotName) return;
      let that = this
      //热点拖拽事件
      this.krpano.get("hotspot[" + spotName + "]").ondown = function (e) {
        that.movingSpot = that.selectHotSpot();
        var intervalId = setInterval(that.autoMove, 1000.0 / 30.0);
        that.krpano.set("autoMoveIntervalId", intervalId);
        that.canShowLeft = false;
      };
      this.krpano.get("hotspot[" + spotName + "]").onup = function () {
        window.clearInterval(that.krpano.get("autoMoveIntervalId"));
        that.movingSpot = {};
        that.canShowLeft = true;
      };
      if (hotspotInfo.peak_type == 3) {
        this.krpano.get("hotspot[" + spotName + "]").onclick = function () {
          // console.log('点击了热点')
          // console.log(hotspotInfo)
          that.goToScene({
            peak_to_scene: hotspotInfo.peak_to_scene,
            peak_to_sceneId: hotspotInfo.peak_to_sceneId,
          });
        }
      } else if (hotspotInfo.peak_type == 1) {//视频类型
        this.krpano.get("hotspot[" + spotName + "]").onclick = this.showVideoLayer.bind(this, hotspotInfo)
      } else if (hotspotInfo.peak_type == 2) {//场景放大
        // this.krpano.get("hotspot[" + spotName + "]").onloaded = 'do_crop_animation(500,500, 60);'
        this.krpano.get("hotspot[" + spotName + "]").onclick = 'looktohotspot(get(name),50);'
      } else if (hotspotInfo.peak_type == 5) {//富文本类型，点击弹出富文本弹窗
        // this.krpano.get("hotspot[" + spotName + "]").onloaded = 'do_crop_animation(500,500, 60);'
        this.krpano.get("hotspot[" + spotName + "]").onclick = this.showEditor.bind(this, hotspotInfo)
      }
      if (hotspotInfo) {
        this.updateHotSpotData()
      }
    },
    //存储热点
    updateHotSpotData() {
      var hotSpotHTML;
      //修改全局变量
      var hotSpotData = [];
      this.krpano.get("hotspot").getArray().forEach(function (everySpot) {
        if (everySpot.name !== "vr_cursor" && everySpot.name !== 'webvr_prev_scene'
            && everySpot.name !== 'webvr_next_scene') {
          var hotSpot = {};
          hotSpot.ath = everySpot.ath.toString();
          hotSpot.atv = everySpot.atv.toString();
          hotSpot.linkedscene = everySpot.linkedscene;
          hotSpot.name = everySpot.name;
          hotSpot.style = everySpot.style;
          hotSpot.title = everySpot.title;
          hotSpot.dive = everySpot.dive;
          hotSpot.loop = everySpot.loop;

          if (everySpot.css && !everySpot.url) {
            hotSpot.url = everySpot.css;
          } else {
            hotSpot.url = everySpot.url;
          }
          hotSpot.edge = everySpot.edge;
          hotSpot.scale = everySpot.scale;
          hotSpot.videourl = everySpot.videourl;
          hotSpot.posterurl = everySpot.posterurl;
          hotSpot.distorted = everySpot.distorted;
          hotSpot.type = everySpot.type;
          hotSpot.pausedonstart = everySpot.pausedonstart;
          hotSpot.peak_type = everySpot.peak_type;
          hotSpot.peak_sceneId = everySpot.peak_sceneId;
          hotSpot.peak_tooltip = everySpot.peak_tooltip;
          hotSpot.peak_to_sceneId = everySpot.peak_to_sceneid;
          hotSpot.peak_to_scene = everySpot.peak_to_scene;
          hotSpot.οnclick = everySpot.οnclick;
          if (everySpot.editorhtml) {
            hotSpot.editorhtml = everySpot.editorhtml;
          }
          if (!everySpot.οnclick) {
            hotSpot.οnclick = 'togglepause()'
          }
          hotSpotData.push(hotSpot);
        }
      });
      this.sceneList[this.currentSceneId].hotSpots = hotSpotData;
      //去掉热点中的文本热点
      let HotSpotList = []
      hotSpotData.forEach(hot => {
        if (hot.peak_type && hot.peak_type != 1) {             //普通热点
          HotSpotList.push(hot)
        }
      })
      this.HotSpotList = HotSpotList
      if (this.audioUrlAct) {
        this.sceneList[this.currentSceneId].audioUrl = this.audioUrlAct

      }

      // console.log(this.sceneList)
    },
    //热点选择模块
    selectHotSpot() {
      this.krpano.call("screentosphere(mouse.x, mouse.y, mouseath, mouseatv);");
      var nearHotSpot = {};
      let that = this
      this.krpano.get("hotspot").getArray().forEach(function (thisHotSpot) {
        var thisAthDis = that.krpano.get("hotspot[" + thisHotSpot.name + "]").ath - that.krpano.get("mouseath");
        var thisAtvDis = that.krpano.get("hotspot[" + thisHotSpot.name + "]").atv - that.krpano.get("mouseatv");
        var thisDis = Math.abs(thisAthDis) + Math.abs(thisAtvDis);
        if (!nearHotSpot.name) {
          nearHotSpot = {name: thisHotSpot.name, athDis: thisAthDis, atvDis: thisAtvDis, dis: thisDis};
        } else {
          if (thisDis < nearHotSpot.dis) {
            nearHotSpot = {name: thisHotSpot.name, athDis: thisAthDis, atvDis: thisAtvDis, dis: thisDis};
          }
        }
      });
      return nearHotSpot;
    },
    //热点移动模块
    autoMove() {
      this.krpano.call("screentosphere(mouse.x, mouse.y, mouseath, mouseatv);");
      this.krpano.set("hotspot[" + this.movingSpot.name + "].ath", this.krpano.get("mouseath") + this.movingSpot.athDis);
      this.krpano.set("hotspot[" + this.movingSpot.name + "].atv", this.krpano.get("mouseatv") + this.movingSpot.atvDis);
      this.updateHotSpotData()//更新场景数据
    },

    /**
     * 获取切换场景的动画类型
     * @param {number} type  跳转的动画类型
     */
    getToggleSceneAnimation(type = 1) {
      let blend;
      switch (type) {
        case 1:
          // 从当前全景图混合/交叉淡入淡出到下一个全景图。
          blend = "BLEND(1.0, easeInCubic)";
          break;
        case 2:
          // 变焦混合
          blend = "ZOOMBLEND(2.0, 2.0, easeInOutSine)";
          break;
        case 3:
          // 打底黑
          blend = "COLORBLEND(2.0, 0x000000, easeOutSine)";
          break;
        case 4:
          // 打底白
          blend = "LIGHTBLEND(1.0, 0xFFFFFF, 2.0, linear)";
          break;
        case 5:
          // 从右到左
          blend = "SLIDEBLEND(1.0, 0.0, 0.2, linear)";
          break;
        case 6:
          // 从上到下
          blend = "SLIDEBLEND(1.0, 90.0, 0.01, linear)";
          break;
        case 7:
          // 沿对角线运动的
          blend = "SLIDEBLEND(1.0, 135.0, 0.4, linear)";
          break;
        case 8:
          // 开口圆
          blend = "OPENBLEND(1.0, 0.0, 0.2, 0.0, linear)";
          break;
        case 9:
          // 垂直性开合
          blend = "OPENBLEND(0.7, 1.0, 0.1, 0.0, linear)";
          break;
        case 10:
          // 水平性开合
          blend = "OPENBLEND(1.0, -1.0, 0.3, 0.0, linear)";
          break;
        case 11:
          // 椭圆+变焦
          blend = "OPENBLEND(1.0, -0.5, 0.3, 0.8, linear)";
          break;

        default:
          break;
      }

      return blend;
    },
    /**
     * 场景结合动画跳转
     * @param {number} obj 信息
     * @param {number} animationType  跳转的动画类型
     */
    goToScene(obj, animationType = 1, is = true) {
      let blend = this.getToggleSceneAnimation(animationType);
      this.krpano.call(`loadscene(${obj.peak_to_scene}, null, MERGE, ${blend})`);//设置当前环境为点击的热点环境
      this.Minikrpano.call(`loadscene(${obj.peak_to_scene}, null, MERGE, ${blend})`);//设置当前小窗环境为点击的热点环境
      this.currentSceneId = obj.peak_to_sceneId;
      //如果之前设置了第一视角就显示第一视角
      if (this.sceneList[this.currentSceneId] && this.sceneList[this.currentSceneId].initH) {
        //设置当前环境第一视角
        this.krpano.set("view.hlookat", this.sceneList[this.currentSceneId].initH);
        this.krpano.set("view.vlookat", this.sceneList[this.currentSceneId].initV);
        //设置小窗第一视角
        this.Minikrpano.set("view.hlookat", this.sceneList[this.currentSceneId].initH);
        this.Minikrpano.set("view.vlookat", this.sceneList[this.currentSceneId].initV);
      }
      this.clearAudio()
      //如果之前有视频关闭视频
      if (this.videoLayerShow) {
        this.videoLayerShow = false
        this.$refs.video.pause();//暂停视频
      }
      let scenceName = this.krpano.get("xml.scene"); // 当前场景图
      // 有很多时候当前场景图拿不到，需要重新调
      let getScenceNameTime = setInterval(() => {
        scenceName = this.krpano.get("xml.scene"); // 当前场景图

        // console.log('切换场景', this.krpano.get("xml.scene"))
        if (scenceName) {
          if (this.krpano.get("scene").getItem(scenceName)) {
            if (this.krpano.get("scene").getItem(scenceName).remark) {
              this.currentSceneName = this.krpano.get("scene").getItem(scenceName).remark;//获取当前场景名称
              this.scenceImgId = this.krpano.get("scene").getItem(scenceName).title
              // console.log('当前场景', that.currentSceneName)
            }
          }
          // 场景加载完成以后再去加载热点
          this.getSceneHotspotNow(this.currentSceneId)
          setTimeout(() => {        // 获取场景的热点
            this.getSceneHotspot();
          }, 1000);
          clearInterval(getScenceNameTime)

        }
      }, 1000)
      // if (scenceName) {//场景加载过慢，需要缓冲重新加载
      // } else {
      // }
    },


    //添加场景事件
    addPano() {
      console.log('添加场景事件')
    },
  },
};
</script>
<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.container {
  width: 100%;
  height: 100%;
  background: #1c283c;
  color: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.overlay-center-pano {

  height: 100%;
  width: 100%;
  max-height: 730px;
  overflow: hidden;
  position: relative;
}

#pano {
  height: 100vh;
  width: 100%;
}

.overlay-view {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  height: 280px;
  z-index: 999;
  margin-top: -150px;
  margin-left: -250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay-view img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}

.overlay-view-title {
  font-size: 16px;
  text-align: center;
  padding: 10px 0;
  background: #2E5CF6;
  border-radius: 4px;
  padding: 7px 20px;
  width: auto;
  height: auto;
  position: absolute;
}

.overlay-left {
  width: 60px;
  height: 100%;
  float: left;
}

.overlay-left-li {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 20%;
  margin-bottom: 30px;
  padding: 10px 0;
}

.overlay-left-li.act {
  background: #2E5CF6;
  border-radius: 4px;
}

.overlay-left-li img {
  width: 22px;
  height: auto;
  margin-bottom: 5px;
}

.overlay-right {
  width: 190px;
  height: auto;
  margin: 0 10px;
}

.overlay-right-title {
  background: #363636;
  width: 100%;
  margin-bottom: 20px;
  width: 100%;
  height: 40px;
  padding: 10px;
  border-radius: 4px;
}

.overlay-center {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.scene-select-box {
  margin-bottom: 10px;

  ul {
    display: flex;

    li {
      margin: 3px;

      img {
        width: 100px;
        height: 100px;
      }
    }
  }

  .hotspot-detail-scene-selected {
    border: solid #409eff 2px;
  }
}

.btn {
  cursor: pointer;
  display: inline-block;
  padding: 8px 20px;
  background-color: rgba(0, 0, 0, .7);
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
}

.btn-blue {
  background-color: #2185D0;
}

.scene-name {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .6);
  color: #fff;
  text-align: right;
  height: 40px;
  line-height: 40px;
  padding-right: 15px;
}

.frame-line {
  position: absolute;
  background-color: #eee;
}

.frame-line-top,
.frame-line-bottom {
  height: 1px;
  left: 30%;
  right: 30%;
}

.frame-line-top {
  top: 25%;
}

.frame-line-bottom {
  bottom: 25%;
}

.frame-line-left,
.frame-line-right {
  top: 25%;
  bottom: 25%;
  width: 1px;
}

.frame-line-left {
  left: 30%;
}

.frame-line-right {
  right: 30%;
}

.angle {
  width: 40px;
  height: 40px;
  position: absolute;
}

.angle i {
  position: absolute;
  background-color: #eee;
}

.angle-a {
  left: 0;
  width: 8px;
  top: 0;
  bottom: 0;
}

.angle-b {
  top: 0;
  left: 0;
  right: 0;
  height: 8px;
}

.angle-tl {
  left: 30%;
  top: 25%;
}

.angle-tr {
  right: 30%;
  top: 25%;
}

.angle-tr .angle-a {
  left: auto;
  right: 0;
}

.angle-bl {
  left: 30%;
  bottom: 25%;
}

.angle-bl .angle-b {
  bottom: 0;
  top: auto;
}

.angle-br {
  right: 30%;
  bottom: 25%;
}

.angle-br .angle-a {
  left: auto;
  right: 0;
}

.angle-br .angle-b {
  top: auto;
  bottom: 0;
}

.frame .btn {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0);
}

.overlay {
  position: absolute;
  right: 415px;
  top: 15px;
  z-index: 9999;
}

.save-wrap {
  margin-top: 40px;
  margin-bottom: 20px;
}

.tool-panel {
  position: relative;
}

.tool-btn-lst {
  float: right;
}

.tool-btn-lst > li {
  margin-bottom: 10px;
  position: relative;
}

.tool-main {
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: absolute;
  z-index: 9999;
  right: 150px;
  top: 100px;
  padding: 15px;
  background-color: rgba(0, 0, 0, .7);
  min-width: 200px;
  border-top: 3px solid #00a3d8;
}

.tool-section {
  border-bottom: 1px solid #2185D0;
  padding: 15px 0;
  color: #ffffff;
}

.tool-section:last-child {
  margin-bottom: 0;
  border-bottom: none;
  padding-bottom: 0;
}

.tool-section:first-child {
  padding-top: 0;
}

.tool-section .active {
  border: 1px solid #2185D0;
}

.tool-section h4 {
  color: #ffffff;
}

.tool-section li {
  display: flex;
  justify-content: space-between;
}

.tool-section .select-span {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.choose-lst {
  margin: 7px 0;
}

.choose-lst li {
  padding: 3px 0;
}

.choose-lst input {
  margin-right: 5px;
}

.left-column {
  position: absolute;
  top: 0;
  left: -250px;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.3);
  width: 250px;
  height: 100%;
  -webkit-animation: hideLeft 0.8s infinite;
  -webkit-animation-iteration-count: 1;
}

@-webkit-keyframes showLeft {
  0% {
    left: -250px;
  }

  100% {
    left: 0;
  }
}

@-webkit-keyframes hideLeft {
  0% {
    left: 0;
  }

  100% {
    left: -250px;
  }
}

.scene-select {
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  padding-bottom: 1px;
  overflow: auto;
  max-height: 600px;
  overflow-x: hidden;
}

.blue-banner {
  background-color: #00a3d8;
  height: 3px;
}

.li-scene {
  list-style-type: none;
  height: 30px;
  border: 2px solid rgba(255, 255, 255, 0);
  margin: 10px;
  width: 200px;
}

.li-scene:hover {
  border-color: #FF9800;
}

.li-scene-hover {
  border-color: #FF9800;
}

.li-scene-span {
  cursor: pointer;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  float: left;
  width: 100px;
  overflow: hidden;
}

.li-scene-input {
  background-color: rgba(185, 185, 185, 0.5);
  height: 30px;
  width: 100px;
  font-size: 18px;
}

.scene-li-button {
  width: 30px;
  height: 30px;
  // background: rgba(255, 255, 255, 0) url("../img/krpano.modify.png");
  border: 0;
  float: right;
  cursor: pointer;
}

.circle {
  width: 30px;
  height: 30px;
  float: right;
  // background: #292827 url("../img/krpano.home.png");
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}

.select_scene_text {
  text-align: center;
  background-color: rgba(40, 40, 40, 0.7);
  height: 50px;
}

.p_title {
  margin-top: 0;
  font-size: 20px;
  line-height: 50px;
}

.add-hot-pot {
  position: absolute;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.8);
  width: 700px;
  height: 440px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.progress-banner {
  margin: 20px;
  background-color: rgba(150, 150, 150, 0.4);
  height: 30px;
}

.progress-title {
  float: left;
  text-align: center;
  width: 33.33%;
  height: 100%;
}

.progress-title-on {
  background-color: #00a3d8;
}

.add-hot-banner {
  font-size: 16px;
  background-color: rgba(150, 150, 150, 0.4);
  padding: 8px 8px 8px 15px;
  height: 20px;
  line-height: 20px;
}

.div-close {
  cursor: pointer;
  float: right;
  font-size: 30px;
}

.add-hot-content {
  margin: 10px 20px 20px 20px;
}

.add-hot-bottom-div {
  height: 250px;
}

.write-title {
  font-size: 18px;
  text-align: center;
}

#addHotTitle {
  color: white;
  width: 57%;
  background-color: rgba(150, 150, 150, 0.4);
}

.add-hot-button {
  cursor: pointer;
  background-color: #00a3d8;
  line-height: 30px;
  text-align: center;
  font-size: 18px;
  height: 30px;
}

.hot-style {
  background-color: rgba(255, 255, 255, 0);
  border: 2px solid rgba(255, 255, 255, 0);
  cursor: pointer;
  margin: 7px;
  width: 64px;
  height: 56px;
  background-size: cover;
  float: left;
}

.hot-spot-img {
  background-color: rgba(255, 255, 255, 0);
  width: 32px;
  height: 32px;
  background-size: cover;
  float: left;
}

.hot-style:hover {
  border: 2px solid orange;
}

.hot-style-on {
  border: 2px solid orange;
}

.select-scene-div {
  float: left;
  width: 80px;
  text-align: center;
  cursor: pointer;
  margin: 5px;
}

.select-scene-div:hover {
  margin: 3px;
  border: 2px solid orange;
}

.select-scene-div-on {
  margin: 3px;
  border: 2px solid orange;
}

.thumbs-img {
  height: 80px;
  background-size: 80px 80px;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.thumbs-img-scene-list {
  width: 30px;
  height: 30px;
  background-size: 30px 30px;
  float: left;
  margin-right: 10px;
}

.hot-pot-select-span {
  position: absolute;
  left: 15px;
  top: 5px;
}

.wait-time-input {
  vertical-align: middle;
  width: 30px;
  background-color: rgba(255, 255, 255, 0.5);
  text-align: center
}

.fov-input {
  vertical-align: middle;
  width: 65px;
  background-color: rgba(255, 255, 255, 0.5);
  text-align: center;
  float: right;
  height: 21px;
}

.hot-spot-list {
  height: 32px;
  width: 200px;
  color: white;
  font-size: 18px;
  border: solid 2px rgba(0, 0, 0, 0);
  margin-top: 5px;
}

.hot-spot-text {
  width: 130px;
  height: 26px;
  float: left;
  text-align: center;
  padding: 3px;
}

.hot-spot-del {
  cursor: pointer;
  width: 32px;
  height: 32px;
  float: left;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.1);
}

.hot-spot-button {
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1);
  height: 32px;
  width: 202px;
  color: white;
  font-size: 18px;
  margin-top: 10px;
}

.hot-spot-list-hover {
  border: solid 2px orange;
}

.number-pb {
  position: relative;
  height: 3px;
  background-color: #ffffff;
  margin: 40px 0;
}

.number-pb .number-pb-shown {
  position: absolute;
  background: #00a3d8;
  left: 0;
  height: 3px;
}

.number-pb .number-pb-num {
  position: absolute;
  background-color: #00a3d8;
  left: 0;
  padding: 0 5px;
}

.triangle-up-left {
  border-bottom: 20px solid #00a3d8;
  margin-top: 3px;
  margin-left: -10px;
}

.triangle-up-right {
  border-bottom: 20px solid #00a3d8;
  margin-top: 3px;
  margin-right: -10px;
}

.triangle-down {
  border-top: 20px solid #00a3d8;
  margin-top: -20px;
  float: none;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}

.my-open-out {
  margin-left: 90px;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  position: relative;
  background: #00a3d8;
}

.my-open-in {
  width: 18px;
  height: 18px;
  border-radius: 9px;
  position: absolute;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  top: 1px;
}

.my-open-in-open {
  right: 1px;
}

.my-open-in-close {
  left: 1px;
}

.dive-text {
  line-height: 20px;
  float: left;
  margin-left: 20px;
}

.action {
  position: fixed;
  z-index: 999;
  left: 0;
  bottom: 0;
}


.frame {
  position: fixed;
  z-index: 9999;
  width: 80%;
  height: 600px;
}

.frame-line {
  position: absolute;
  background-color: #eee;
}

.frame-line-top,
.frame-line-bottom {
  height: 1px;
  left: 30%;
  right: 30%;
}

.frame-line-top {
  top: 25%;
}

.frame-line-bottom {
  bottom: 25%;
}

.frame-line-left,
.frame-line-right {
  top: 25%;
  bottom: 25%;
  width: 1px;
}

.frame-line-left {
  left: 30%;
}

.frame-line-right {
  right: 30%;
}

.frame .btn {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0);
}

.tool_header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tool_header img {
  width: auto;
  height: 14px;
  margin-right: 10px;
}

.tool_header_left {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #363636;
  padding: 5px 10px;
  margin: 10px;
  border-radius: 4px;
  border: none;
  color: #ffffff;
}

.tool_header_left.act {
  background-color: #2E5CF6;
}

.tool_main {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.tool-right-section {
  width: 100%;
  height: auto;
  background: #363636;
  padding: 10px;
  border-radius: 4px;
}

.tool-right-section-content {
  width: 100%;
  height: 60px;
  margin-top: 10px;
  position: relative;
}

.tool-right-input {
  width: 100%;
  height: 30px;
  line-height: 30px;
  border: none;
  background: #4D4D4D;
  border-radius: 4px;
  color: #ffffff;
  border: none;
  padding: 0 10px;
  margin-top: 10px;
  margin-right: 10px;
}

.tool-right-section-content-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}

#panoMini {
  width: 100%;
  height: 60px;
}

.tool-right-section-ul {
  width: 100%;
  height: auto;
  max-height: 75vh;
  overflow: auto;
}

.tool-right-section-ul li {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #363636;
  border-radius: 4px;
  padding: 0 4px;
}

.tool-right-section-ul li .section-img {
  width: 24px;
  height: 20px;
  margin-right: 3px;
}

.tool-right-section-ul li .section-span1 {
  width: auto;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 101px;
  overflow: hidden;
}

.tool-right-section-ul li .section-span1 span {
  max-width: 101px;
  overflow: hidden; /* 隐藏超出的文本 */
  white-space: nowrap; /* 保持文本在一行内显示 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}

.tool-right-section-ul li .section-span {
  width: 10px;
  height: 10px;
}

.tool-right-but {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #2E5CF6;
  margin-top: 10px;
  border-radius: 4px;
  border: none;
  color: #ffffff;
}

.tool-right-but1 {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #4D4D4D;
  margin-top: 10px;
  border-radius: 4px;
  border: none;
  color: #ffffff;
}


.mssage {
  position: fixed;
  top: -200px;
  left: 50%;
  width: 200px;
  height: auto;
  margin-left: -100px;
  padding: 10px;
  border-radius: 5px;
  background: #4D4D4D;
  z-index: 9999;
  text-align: center;
}

.mssage.act {
  opacity: 1;
  top: 100px;
  animation: myfirst 3s;
  -webkit-animation: myfirst 3s;
  /* Safari and Chrome */
}

@keyframes myfirst {
  0% {
    top: -200px;
  }

  25% {
    top: 100px;
  }

  50% {
    top: 100px;
  }

  75% {
    top: 100px;
  }

  100% {
    top: -200px;
  }
}

@-webkit-keyframes myfirst

  /* Safari 与 Chrome */
{
  0% {
    top: -200px;
  }

  25% {
    top: 100px;
  }

  50% {
    top: 100px;
  }

  75% {
    top: 100px;
  }

  100% {
    top: -200px;
  }
}

.audioact {
  border: 2px solid #2E5CF6 !important;
}

.panoAudio {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 9999;
  background: #36363680;
  padding: 4px;
  border-radius: 4px;
}

.overlay-video {
  width: 100%;
  height: 100%;
}

.overlay-but {
  position: absolute;
  top: 7px;
  right: 7px;
  z-index: 9999999;
  width: 15px;
  height: 15px;
}

.overlay-but img {

  width: 15px;
  height: 15px;
}

.loading {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1c283c99;
}

.loading img {
  width: 160px;
  height: 160px;
}

.edit_container {
  width: 70%;
  height: 80%;
  background: #ffffff;
  position: absolute;
  z-index: 999999;
  top: 8%;
  left: 15%;
  //padding: 10px;
  border-radius: 10px;
  color: #000000;
  overflow: hidden;
}

.edit_close {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 13px;
  background: #fff;
  border-radius: 18px;
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
}

.edit_close img {
  width: 10px;
  height: 10px;
}

.quill-but {
  position: absolute;
  bottom: 17px;
  left: 50%;
  width: 200px;
  margin-left: -100px;
}

.quill-main {
  width: 100%;
  height: 100%;
  overflow: auto;
  border-radius: 10px;
}
</style>
